export const useNavConfig = () => [
  { title: 'Track dashboard', path: 'https://track.citizenshipper.tools/' },
  { title: 'Open-source notices', path: '/open-source/' },
];
